var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport32Cd58A0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_447_66)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_447_66",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_447_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.683 13.683C33.683 6.12609 27.5569 0 20 0C12.4431 0 6.31701 6.12609 6.31701 13.683C4.36338 13.9263 2.51617 15.2033 2.51617 18.168V25.3136C2.51617 28.6583 4.85749 29.8746 7.07718 29.8746H9.28166C9.70147 29.8746 10.0418 29.5342 10.0418 29.1144V14.3976C10.0418 13.9778 9.70147 13.6374 9.28166 13.6374H7.83735C7.83735 6.92018 13.2828 1.47472 20 1.47472C26.7172 1.47472 32.1627 6.92018 32.1627 13.6374H30.7184C30.2986 13.6374 29.9582 13.9778 29.9582 14.3976V29.0916C29.9582 29.5114 30.2986 29.8518 30.7184 29.8518H32.1627C31.9499 35.0741 29.4413 36.298 24.4318 36.5184V36.0091C24.4318 35.1694 23.7512 34.4888 22.9115 34.4888H18.13C17.2903 34.4888 16.6097 35.1694 16.6097 36.0091V38.4797C16.6097 39.3194 17.2903 40 18.13 40H22.9267C23.7664 40 24.447 39.3194 24.447 38.4797V38.0388C29.2665 37.8183 33.4322 36.8225 33.683 29.8062C35.6367 29.5629 37.4839 28.2858 37.4839 25.3212V18.1756C37.4839 15.1957 35.6443 13.9263 33.683 13.683ZM8.5215 15.1045V28.3314H7.03917C5.91412 28.3314 3.9985 27.9361 3.9985 25.2908V18.1452C3.9985 15.5226 5.89132 15.1045 7.03917 15.1045H8.5215ZM22.9267 37.3318V38.4873H18.13V36.0167H22.9267V37.3318ZM35.9635 25.3136C35.9635 27.9361 34.0707 28.3542 32.9229 28.3542H31.4786V15.1577H32.9609C34.0859 15.1577 36.0016 15.553 36.0016 18.1984L35.9635 25.3136Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_447_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport32Cd58A0);
export default __webpack_public_path__ + "static/media/Support.32cd58a0.615dae15d0a08fda17965f2833a241cd.svg";
export { ForwardRef as ReactComponent };